/* ============================================================
   TDHQ page sections behaviour — tdhq-page.js

   Only two jobs: conditional contact-form fields, and moving focus to
   the form's confirmation or error message after a submit.

   Everything else in the page library is CSS and semantic HTML on
   purpose — the FAQ accordion is <details>, the steps are an <ol>, the
   cards are <a> elements. Nothing here is required to use a page.
   ============================================================ */
(function () {
  'use strict';

  if (window.__tdhqPageLoaded) return;
  window.__tdhqPageLoaded = true;

  /* ---------------------------------------------------------
     CONDITIONAL CONTACT FIELDS
     --------------------------------------------------------- */
  function wireConditionalFields(scope) {
    // Scoped rather than document-wide: Product Advice and Apply for Trade can
    // both appear as forms on one page, and a global lookup would let the first
    // form's controller drive the second form's fields.
    var select = scope.querySelector('[data-tdhq-enquiry-type], [data-tdhq-controller]');
    var groups = scope.querySelectorAll('[data-tdhq-when]');
    var conditionallyRequired = scope.querySelectorAll('[data-tdhq-required-when]');
    if (!select || (!groups.length && !conditionallyRequired.length)) return;

    function apply() {
      var value = controlValue(select);
      Array.prototype.forEach.call(groups, function (group) {
        var matches = group.getAttribute('data-tdhq-when').split(',').map(function (s) {
          return s.trim();
        });
        var show = matches.indexOf(value) !== -1;
        group.hidden = !show;

        // A hidden field must never be submitted or block validation. Clearing
        // the value also stops stale answers from a previously-selected enquiry
        // type reaching the inbox and confusing whoever reads it.
        Array.prototype.forEach.call(group.querySelectorAll('input, select, textarea'), function (field) {
          field.disabled = !show;
          if (!show) {
            if (field.tagName === 'SELECT') { field.selectedIndex = 0; }
            else { field.value = ''; }
          }
        });
      });
    }

    /* A field that is only NEEDED for some answers - the telephone number when
       the customer asks to be phoned. It stays visible and optional otherwise,
       so the form does not grow and shrink as they answer; only the asterisk
       and the browser's own validation change.

       The condition NAMES ITS OWN CONTROLLER, because the field it depends on
       is usually not the one that shows and hides groups: on Product Advice the
       groups follow "Advice type" while the telephone number follows "Preferred
       reply". Written as "Preferred reply: Telephone, WhatsApp"; with no label
       before the colon it falls back to the section's main controller. */
    function parseCondition(raw) {
      var i = raw.indexOf(':');
      var field = i > -1 ? raw.slice(0, i).trim() : '';
      var values = (i > -1 ? raw.slice(i + 1) : raw).split(',').map(function (v) { return v.trim(); });
      return { field: field, values: values };
    }

    function controllerFor(name) {
      if (!name) { return select; }
      return scope.querySelector('[name="contact[' + name.replace(/"/g, '') + ']"]') || select;
    }

    /* A RADIO GROUP HAS NO SINGLE ELEMENT TO READ. controllerFor hands back the
       FIRST member of the group, and its .value is its own option - "Email" -
       whether or not it is the one chosen. Preferred reply method is a radio
       group now (brief 36), so read the member that is actually checked. */
    function controlValue(ctl) {
      if (!ctl) { return ''; }
      if (ctl.type === 'radio' && ctl.name) {
        var chosen = scope.querySelector('[name="' + ctl.name.replace(/"/g, '') + '"]:checked');
        return chosen ? chosen.value : '';
      }
      return ctl.value;
    }

    function applyRequired() {
      Array.prototype.forEach.call(conditionallyRequired, function (group) {
        var cond = parseCondition(group.getAttribute('data-tdhq-required-when') || '');
        var ctl = controllerFor(cond.field);
        var need = !!ctl && cond.values.indexOf(controlValue(ctl)) !== -1;
        /* Never required while hidden: the browser refuses to submit and points
           at a control that is not on screen. */
        if (group.hidden) { need = false; }
        Array.prototype.forEach.call(group.querySelectorAll('input, select, textarea'), function (field) {
          field.required = need;
          field.setAttribute('aria-required', need ? 'true' : 'false');
        });
      });
    }

    var applyAll = function () { apply(); applyRequired(); };
    select.addEventListener('change', applyAll);

    /* Listen to every field a condition names, once each. */
    var watched = [];
    Array.prototype.forEach.call(conditionallyRequired, function (group) {
      var cond = parseCondition(group.getAttribute('data-tdhq-required-when') || '');
      var ctl = controllerFor(cond.field);
      if (ctl && ctl !== select && watched.indexOf(ctl) === -1) {
        watched.push(ctl);
        /* One radio only hears its OWN change, so the group is watched through
           the form wrapper the events bubble to instead. Registering the same
           function twice on the same element is a no-op, so two conditions on
           two groups still bind once. */
        if (ctl.type === 'radio') { scope.addEventListener('change', applyRequired); }
        else { ctl.addEventListener('change', applyRequired); }
      }
    });
    // Run once on load: the groups render visible so a no-JS visitor sees
    // everything, and this collapses them to the relevant set.
    applyAll();

    /* ---- ROUTE LINKS PRESELECT THE ADVICE TYPE (brief 16-21, 49) ----

       The six advice route cards and the fitting band's Upload My Fitting
       Photos all lead to this one form, and they used to land on it with
       nothing chosen: the customer answers "what do you need help with?"
       once by choosing a card and again by finding the same words in a list.

       The choice travels in ?advice=<option value>. On load it is applied only
       while the list is still unanswered, so a half-filled form that is
       reloaded is never rewritten. A click on a link on THIS page applies it
       with no page load at all, which is also what stops anything already
       typed from being thrown away. Neither ever submits the form. */
    function focusAfterController() {
      var all = scope.querySelectorAll('input, select, textarea');
      var passed = false;
      for (var i = 0; i < all.length; i++) {
        if (all[i] === select) { passed = true; continue; }
        if (!passed || all[i].disabled || all[i].type === 'hidden') { continue; }
        var box = all[i].getBoundingClientRect();
        if (!box.width && !box.height) { continue; }
        /* preventScroll: the browser has just jumped to the form's anchor, or
           is scrolling to it below. Focusing would otherwise move the page a
           second time, under the reader. */
        try { all[i].focus({ preventScroll: true }); } catch (err) { all[i].focus(); }
        return;
      }
    }

    function preselect(value, moveFocus) {
      if (!value || !select.options) { return false; }
      for (var i = 0; i < select.options.length; i++) {
        if (select.options[i].value !== value) { continue; }
        if (select.value !== value) {
          select.value = value;
          /* A real change event: the custom dropdown repaints from it and the
             conditional fields re-run. */
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (moveFocus) { focusAfterController(); }
        return true;
      }
      return false;
    }

    function adviceFrom(search) {
      try { return new URLSearchParams(search).get('advice') || ''; }
      catch (err) { return ''; }
    }

    if (!select.value) { preselect(adviceFrom(window.location.search), true); }

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) { return; }
      var link = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!link || link.target === '_blank') { return; }
      var url;
      try { url = new URL(link.href, window.location.href); } catch (err) { return; }
      /* Only a link back to THIS page: from anywhere else it is an ordinary
         navigation and the load-time branch above picks the choice up. */
      if (url.pathname !== window.location.pathname) { return; }
      var want = adviceFrom(url.search);
      if (!want || !preselect(want, false)) { return; }
      e.preventDefault();
      var target = url.hash ? document.getElementById(url.hash.slice(1)) : null;
      if (target) {
        var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
      }
      focusAfterController();
      /* The address bar keeps the choice, so the page can be shared or
         reloaded and land the same way. Nothing personal is in it. */
      try { window.history.replaceState(null, '', url.pathname + url.search + url.hash); } catch (err) {}
    });
  }

  function initForms(root) {
    var forms = root.querySelectorAll('[data-tdhq-form]');
    if (forms.length) {
      Array.prototype.forEach.call(forms, wireConditionalFields);
    } else if (root === document) {
      // The original contact form predates the wrapper attribute.
      wireConditionalFields(document);
    }
  }

  /* ---------------------------------------------------------
     COLLECTION FILTER PANEL (narrow screens only)

     The panel renders OPEN. This collapses it below the breakpoint, which is
     the safe direction: if this script never runs, the filters are still on the
     page and still work, because filtering is a plain GET form.

     Desktop is never touched — there the panel is a sidebar and the trigger is
     display:none, so collapsing it would hide filters with no way back.
     --------------------------------------------------------- */
  /* Named and idempotent so the Section-Rendering swap below can re-run it on
     the freshly injected markup — injected HTML never executes scripts and
     never inherits element-bound listeners. */
  /* THE PANEL'S STATE OUTLIVES THE SECTION. Every facet tick replaces the
     whole collection section, and initCollectionUI() runs again on the fresh
     markup - so anything kept inside it is both re-created and never cleaned
     up. Two faults came out of that: the media-query listener was registered
     once per swap and never removed (three ticks, three listeners, one live
     panel), and applyBreakpoint() collapsed the panel again after every tick,
     so a phone shopper could apply exactly one filter per opening.

     The query, its listener and the shopper's own choice therefore live here,
     at page scope, and are looked up through the CURRENT root each time. */
  /* 999px, matching the CSS rule that hides the panel (assets/tdhq-page.css,
     inside @media (max-width: 999px)). At 899 they disagreed, so between 900
     and 999 the panel stayed open in flow with no way to close it. */
  var facetsNarrow = window.matchMedia('(max-width: 999px)');
  var facetsOpenedByUser = null;   /* null = never touched; true = they opened it */

  function facetsParts() {
    var root = document.querySelector('[data-tdhq-collection]');
    if (!root) { return null; }
    var toggle = root.querySelector('[data-tdhq-facets-toggle]');
    var panel = root.querySelector('[data-tdhq-facets]');
    if (!toggle || !panel) { return null; }
    return { root: root, toggle: toggle, panel: panel };
  }

  /* The state is named for what is TRUE of the markup the server sends:
     closed. The script adds the class to OPEN the panel, so nothing has to
     move after the page has painted. */
  /* BELOW 1000PX THE OPEN PANEL IS A MODAL DRAWER (tdhq-page.css, audit
     LST-03): the page behind is locked with the one scroll-lock class, the
     panel is announced as a dialog named by its "Filter" title, focus stays
     inside it, and the close button, the scrim, Escape and the results button
     all close it and hand focus back to the Filter button. On the desktop rail
     none of that applies: it is a sidebar, not a dialog. */
  var facetsLocked = false;
  function lockFacetsPage(on) {
    if (on === facetsLocked) { return; }
    facetsLocked = on;
    document.documentElement.classList.toggle('tdhq-modal-open', on);
  }

  function setFacetsOpen(on) {
    var p = facetsParts();
    if (!p) { lockFacetsPage(false); return; }
    p.root.classList.toggle('is-facets-open', on);
    p.toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
    var modal = on && facetsNarrow.matches;
    lockFacetsPage(modal);
    if (modal) {
      p.panel.setAttribute('role', 'dialog');
      p.panel.setAttribute('aria-modal', 'true');
      p.panel.setAttribute('aria-labelledby', 'tdhq-facets-title');
    } else {
      p.panel.removeAttribute('role');
      p.panel.removeAttribute('aria-modal');
      p.panel.removeAttribute('aria-labelledby');
    }
  }

  function facetsDrawerOpen() {
    var p = facetsParts();
    return !!(p && facetsNarrow.matches && p.root.classList.contains('is-facets-open'));
  }

  function closeFacetsDrawer() {
    facetsOpenedByUser = false;
    setFacetsOpen(false);
    var p = facetsParts();
    if (p) { p.toggle.focus({ preventScroll: true }); }
  }

  /* Delegated: every filter tick replaces the section, and these must keep
     working on the fresh markup. The results button closes the drawer and
     lets its form submit go ahead (tdhq-page.js below renders the results). */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) { return; }
    if (e.target.closest('[data-tdhq-facets-close]')) {
      e.preventDefault();
      closeFacetsDrawer();
      return;
    }
    if (e.target.closest('[data-tdhq-facets-apply]') && facetsDrawerOpen()) {
      /* Only a form that will actually submit closes the drawer: an invalid price would otherwise be hidden with
         its message (Codex filters-1021 F09). */
      var applyForm = e.target.closest('form');
      if (!applyForm || applyForm.checkValidity()) { closeFacetsDrawer(); }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!facetsDrawerOpen()) { return; }
    var p = facetsParts();
    if (e.key === 'Escape') {
      /* A custom dropdown open inside the panel closes first. */
      if (e.defaultPrevented) { return; }
      e.preventDefault();
      closeFacetsDrawer();
      return;
    }
    if (e.key !== 'Tab') { return; }
    var f = Array.prototype.filter.call(
      p.panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'),
      function (n) { return n.offsetParent !== null || n === document.activeElement; }
    );
    if (!f.length) { return; }
    var first = f[0], last = f[f.length - 1];
    if (!p.panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* Collapsed below the breakpoint UNLESS the shopper opened it, in which case
     it stays open across as many filter applications as they want. Desktop is
     never touched: there the panel is a sidebar and the trigger is
     display:none, so collapsing would hide the filters with no way back. */
  function applyFacetsBreakpoint() {
    if (!facetsNarrow.matches) { setFacetsOpen(true); return; }
    setFacetsOpen(facetsOpenedByUser === true);
  }

  /* Crossing the breakpoint is a real change of context - a rotated phone, a
     resized window - so the remembered choice is forgotten there, and only
     there. */
  function onFacetsBreakpointChange() {
    facetsOpenedByUser = null;
    applyFacetsBreakpoint();
  }
  // addEventListener on MediaQueryList is not in older Safari; addListener is.
  if (facetsNarrow.addEventListener) { facetsNarrow.addEventListener('change', onFacetsBreakpointChange); }
  else if (facetsNarrow.addListener) { facetsNarrow.addListener(onFacetsBreakpointChange); }

  /* ---------------------------------------------------------
     LONG FACET LISTS: SHOW ALL / SHOW FEWER

     A list longer than ten values renders its first eight and a button
     (sections/tdhq-collection.liquid). It replaced a 300px inner scroller
     that hid 20 of Interior's 27 brands behind a fade with no control, so
     the last visible brand looked disabled. Without script every value shows
     and the button stays hidden (html.js gates both in the CSS).

     Every filter tick replaces the section, so the shopper's choice is kept
     here per facet and put back on the fresh markup; a choice they made wins
     over the server's "a ticked value is hidden, open it" default. The rail
     stays pinned under the header and scrolls inside itself (21 Oct), so a
     list opening or closing never moves the page.
     --------------------------------------------------------- */
  var facetListsOpen = {};

  function setFacetList(btn, list, open) {
    list.classList.toggle('is-expanded', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.textContent = btn.getAttribute(open ? 'data-label-less' : 'data-label-more') || btn.textContent;
  }

  /* GROUPS KEEP THE STATE THE SHOPPER GAVE THEM (Codex filters-1021 F04): every group renders open, so a group
     closed before a filter tick came back open with the new markup. The choice is recorded at the summary click
     (before the disclosure animation runs) and put back on every re-render. */
  var facetGroupsOpen = {};
  document.addEventListener('click', function (e) {
    var sum = e.target.closest && e.target.closest('details[data-tdhq-facet-group] > summary');
    if (!sum) { return; }
    var d = sum.parentNode;
    facetGroupsOpen[d.getAttribute('data-tdhq-facet-group')] = !d.open;
  }, true);

  function syncFacetGroups(root) {
    Array.prototype.forEach.call(root.querySelectorAll('details[data-tdhq-facet-group]'), function (d) {
      var key = d.getAttribute('data-tdhq-facet-group');
      if (Object.prototype.hasOwnProperty.call(facetGroupsOpen, key)) { d.open = facetGroupsOpen[key]; }
    });
  }

  function syncFacetLists(root) {
    syncFacetGroups(root);
    Array.prototype.forEach.call(root.querySelectorAll('[data-tdhq-facets-more]'), function (btn) {
      var list = document.getElementById(btn.getAttribute('aria-controls'));
      if (!list) { return; }
      var key = list.getAttribute('data-tdhq-facet') || list.id;
      var open = Object.prototype.hasOwnProperty.call(facetListsOpen, key) ? facetListsOpen[key] : list.classList.contains('is-expanded');
      setFacetList(btn, list, open);
    });
  }

  /* SHOW ALL OPENS LIKE THE GROUPS DO (audit LST-19). The facet groups open
     and close over ~200ms, but "Show all 48" took the Brand list from 302px to
     1851px between two frames and everything below it jumped. The list now
     grows and shrinks over the motion token (--tdhq-t, 220ms) with the shared
     easing, and the rows it reveals fade in; closing keeps them on show until
     the list has shrunk past them. Only on the shopper's click - the state put
     back after a filter re-render is never animated. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tdhq-facets-more]');
    if (!btn) { return; }
    var list = document.getElementById(btn.getAttribute('aria-controls'));
    if (!list) { return; }
    var open = btn.getAttribute('aria-expanded') !== 'true';
    var rail = btn.closest('[data-tdhq-facets]');
    facetListsOpen[list.getAttribute('data-tdhq-facet') || list.id] = open;
    // Closing a long list must not leave the shopper scrolled past it: once it has shrunk, the rail (its own scroller)
    // brings the Show all button back into view, clear of the pinned Apply bar.
    var keepInView = function () {
      if (open || !rail || rail.scrollHeight <= rail.clientHeight) { return; }
      var r = rail.getBoundingClientRect(), b = btn.getBoundingClientRect();
      var foot = rail.querySelector('.tdhq-facets__foot');
      var bottom = r.bottom - (foot ? foot.offsetHeight : 0) - 12;
      if (b.top < r.top + 12) { rail.scrollTop -= r.top + 12 - b.top; }
      else if (b.bottom > bottom) { rail.scrollTop += b.bottom - bottom; }
    };
    /* The label changes on the click; the rows move with TdhqMotion.resize (one height glide per list, a second click
       mid-way starts from where the list is, Codex filters-1021 F20), and the closing rows stay until the list is shut. */
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.textContent = btn.getAttribute(open ? 'data-label-less' : 'data-label-more') || btn.textContent;
    var shown = function (o) { list.classList.toggle('is-expanded', o); };
    var M = window.TdhqMotion;
    if (!M || !M.resize) { shown(open); keepInView(); return; }
    var anim = M.resize(list, shown, open, true, keepInView);
    if (anim && open) {
      Array.prototype.slice.call(list.children, 8).forEach(function (row) {
        row.animate([{ opacity: 0 }, { opacity: 1 }], { duration: M.ms('--tdhq-t', 220), easing: M.easing() });
      });
    }
    /* Keyboard: the first value the list revealed takes focus, as in Shopify's Dawn (F19). A mouse click keeps
       focus where it is (e.detail is 0 only for keyboard activation). */
    if (open && e.detail === 0) {
      var firstNew = list.children[8] && list.children[8].querySelector('input:not([disabled])');
      if (firstNew) { firstNew.focus({ preventScroll: true }); }
    }
  });

  function initCollectionUI() {
    var root = document.querySelector('[data-tdhq-collection]');
    if (!root || root.dataset.tdhqUiReady) return;
    root.dataset.tdhqUiReady = '1';
    syncFacetLists(root);
    var toggle = root.querySelector('[data-tdhq-facets-toggle]');
    var panel = root.querySelector('[data-tdhq-facets]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      var isCollapsed = !root.classList.contains('is-facets-open');
      facetsOpenedByUser = isCollapsed;
      setFacetsOpen(isCollapsed);
      if (isCollapsed) {
        // Opening: move focus into the panel so a keyboard user lands on the
        // first control rather than staying on the trigger.
        /* not a hidden field: the search page's rail carries its query in some */
        var first = panel.querySelector('select, input:not([type="hidden"]), summary, button');
        if (first) first.focus({ preventScroll: true });
      }
    });

    applyFacetsBreakpoint();

    /* Sort submits immediately — it is a single choice, so batching it behind
       Apply would just be a second click. The filter checkboxes deliberately do
       NOT auto-submit: until no-reload filtering lands, each tick would cost a
       full page load, so they are batched behind Apply. */
    var sort = root.querySelector('[data-tdhq-sort]');
    var form = root.querySelector('[data-tdhq-facets-form]');
    if (sort && form) {
      sort.addEventListener('change', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }

    /* With no-reload filtering live (below), each checkbox tick can apply
       immediately — the debounce batches a quick run of ticks into one
       request. The Apply button still works and is the no-JS fallback. */
    /* A reversed price range (minimum above maximum) is swapped before it is sent (Codex filters-1021 F16). The
       listener runs in the capture phase, before the no-reload submit handler reads the form. */
    form && form.addEventListener('submit', function () {
      var lo = form.querySelector('input[name="filter.v.price.gte"]');
      var hi = form.querySelector('input[name="filter.v.price.lte"]');
      if (lo && hi && lo.value !== '' && hi.value !== '' && Number(lo.value) > Number(hi.value)) {
        var t = lo.value; lo.value = hi.value; hi.value = t;
      }
    }, true);
    var debounce;
    form && form.addEventListener('change', function (e) {
      if (e.target.type !== 'checkbox' && e.target.type !== 'number') return;
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      }, 350);
    });
  }
  initCollectionUI();

  /* ---------------------------------------------------------
     INSTANT PAGINATION + FILTERING — Section Rendering API.

     Per shopify.dev best practice: fetch the SAME url with
     `sections=<id>`, which returns { "<id>": "<rendered html>" },
     then replace the section wrapper's outerHTML (innerHTML would
     nest a second wrapper and duplicate its id). Rendering stays
     in Liquid; this script only fetches and swaps.

     Listeners are DELEGATED on document so they survive every
     swap; per-element UI is re-initialised via initCollectionUI().
     Plain links and the GET form remain the no-JS fallback.
     --------------------------------------------------------- */
  (function collectionAjax() {
    if (!('fetch' in window) || !window.history || !window.history.pushState) return;

    var inflight = null;
    var loadSeq = 0;

    /* ---- SOLD-OUT LAST, ACROSS EVERY PAGE ----------------------------------
       Shopify has no sort that puts sold-out products last, and paginate
       orders a page before Liquid sees it, so the section's own two-pass loop
       could only reorder within one page. This builds page P from Shopify's
       availability filter instead - in-stock list first, sold-out list after -
       so every sold-out product comes after every in-stock one, under any sort
       and any other filter, and moves back by itself when it is restocked.
       The figures come from Liquid on the grid (data-sf-*). A product with some
       variants left is in BOTH filter lists, so sold-out cards are taken from
       the out-of-stock list with still-available products removed, and
       (in + out - total) bounds how far that list is read. Anything that does
       not add up leaves the server's page exactly as it was. */
    var sfCache = {};
    function sfGet(url) {
      if (!sfCache[url]) {
        sfCache[url] = fetch(url).then(function (r) {
          if (!r.ok) { throw new Error('HTTP ' + r.status); }
          return r.json();
        });
        sfCache[url].catch(function () { delete sfCache[url]; });
      }
      return sfCache[url];
    }
    function sfCards(html) {
      var tpl = document.createElement('template');
      tpl.innerHTML = html || '';
      var g = tpl.content.querySelector('[data-tdhq-collection-grid]');
      return g ? Array.prototype.slice.call(g.children) : [];
    }
    function sfIsOut(card) {
      return card.classList.contains('tdhq-pcard--out') || !!card.querySelector('.tdhq-pcard--out');
    }
    function sfKey(card) {
      var a = card.querySelector('a[href*="/products/"]');
      return a ? a.getAttribute('href').split('?')[0] : '';
    }
    /* PAINT ONCE (the client's "products appear twice", audit LST-01/LST-02).
       This used to rebuild the grid the shopper was already looking at: on
       GYEON row 1 card 4 painted as a sold-out tar remover and turned into a
       sticker 200ms later, and every sold-out card below shifted a slot. Now
       the section marks the cards this pass may still replace
       (data-sf-pending: the sold-out cards on page 1, every card on a later
       page) and tdhq-fix-listing.css keeps them invisible until it resolves.
       stockFirst() only works out the order; sfApply() writes it and
       sfRelease() shows what was held, so each slot is painted once, with its
       final card. */
    function stockFirst(root, sectionId, pageUrl) {
      var g = root.querySelector('[data-tdhq-collection-grid][data-sf-param]');
      if (!g) { return Promise.resolve(null); }
      var d = g.dataset;
      var inN = +d.sfIn, outN = +d.sfOut, total = +d.sfTotal, page = +d.sfPage, size = +d.sfSize;
      if (!(inN > 0 && total > inN && size > 0 && page > 0)) { return Promise.resolve(null); }
      var start = (page - 1) * size;
      var end = Math.min(page * size, total);
      if (start >= total) { return Promise.resolve(null); }
      var current = Array.prototype.slice.call(g.children);
      /* Page 1 with no sold-out card on it is already the first page of the
         in-stock list. */
      if (page === 1 && !current.some(sfIsOut)) { return Promise.resolve(null); }
      var dup = Math.max(0, inN + outN - total);
      var inCount = Math.max(0, Math.min(end, inN) - start);
      var outFrom = Math.max(start, inN) - inN;
      var outCount = end - Math.max(start, inN);
      var outPages = outCount > 0 ? Math.ceil((outFrom + outCount + dup) / size) : 0;
      if (outPages > 12) { return Promise.resolve(null); }

      function listUrl(value, n) {
        var u = new URL(pageUrl, window.location.origin);
        u.searchParams.delete('page');
        u.searchParams.delete('sections');
        u.searchParams.delete(d.sfParam);
        u.searchParams.append(d.sfParam, value);
        if (n > 1) { u.searchParams.set('page', String(n)); }
        u.searchParams.set('sections', sectionId);
        return u.pathname + '?' + u.searchParams.toString();
      }

      var inJob = inCount > 0
        ? sfGet(listUrl(d.sfInValue, page)).then(function (data) { return sfCards(data[sectionId]).slice(0, inCount); })
        : Promise.resolve([]);
      var outJobs = [];
      for (var q = 1; q <= outPages; q++) { outJobs.push(sfGet(listUrl(d.sfOutValue, q))); }
      var outJob = Promise.all(outJobs).then(function (list) {
        var cards = [];
        list.forEach(function (data) { cards = cards.concat(sfCards(data[sectionId]).filter(sfIsOut)); });
        return cards.slice(outFrom, outFrom + outCount);
      });

      return Promise.all([inJob, outJob]).then(function (parts) {
        var next = parts[0].concat(parts[1]);
        /* Stock changed between requests, or a list came back short: keep the
           server's page rather than show a wrong one. */
        if (next.length !== end - start) { return null; }
        var same = next.length === current.length && next.every(function (c, i) { return sfKey(c) === sfKey(current[i]); });
        return same ? null : next;
      });
    }
    /* On show: in the document and not held back by data-sf-pending. A grid
       built off-screen (a filter, sort or page swap) has nothing on show. */
    function sfShown(card) {
      return card.isConnected && window.getComputedStyle(card).visibility === 'visible';
    }
    /* Writes the planned order. Cards the shopper can already see are never
       moved: the order is written from the first slot that differs or was held
       back, and every card placed from there on is new or was invisible until
       now, so it is first seen as it arrives (with the grid's fade on a swap).
       This used to settle the whole grid (is-settled) before re-appending every
       card, which stopped the replay but also killed the entrance of a freshly
       fetched page, so a filter, sort or page change snapped in (audit MOT-08). */
    function sfApply(g, next) {
      var current = Array.prototype.slice.call(g.children);
      var byKey = {};
      current.forEach(function (c) { var k = sfKey(c); if (k && !byKey[k]) { byKey[k] = c; } });
      var revealed = current.some(function (c) {
        return c.classList.contains('is-in') || !!c.querySelector('.is-in');
      });
      var ordered = next.map(function (c) {
        var k = sfKey(c);
        if (k && byKey[k]) { var have = byKey[k]; delete byKey[k]; return have; }
        if (revealed) {
          if (c.className && String(c.className).indexOf('reveal') > -1) { c.classList.add('is-in'); }
          Array.prototype.forEach.call(c.querySelectorAll('[class*="reveal"]'), function (n) { n.classList.add('is-in'); });
        }
        return c;
      });
      /* U.52: every card's on-show state is read before anything moves. Read
         between the moves, each read made the browser restyle the grid again
         (Lighthouse forced reflow, ~50 ms on a phone collection page). Moving
         a card never changes whether another is on show: that depends only on
         the grid's data-sf-pending and the card's own sold-out class. */
      var shown = ordered.map(sfShown);
      var keep = 0;
      while (keep < ordered.length && ordered[keep] === current[keep] && shown[keep]) { keep++; }
      var move = function () {
        current.forEach(function (c) { if (ordered.indexOf(c) === -1) { g.removeChild(c); } });
        for (var i = keep; i < ordered.length; i++) {
          /* On show and still having to move (the in-stock list came back in
             another order): it slides to its place without a second entrance. */
          if (shown[i]) { ordered[i].classList.add('tdhq-sf-kept'); }
          g.appendChild(ordered[i]);
        }
      };
      /* cards already on show GLIDE to their new places (TdhqMotion.flip, 21 Oct); measured only when one moves */
      var visibleMoves = false;
      for (var s = keep; s < ordered.length; s++) { if (shown[s]) { visibleMoves = true; break; } }
      if (visibleMoves && window.TdhqMotion) { window.TdhqMotion.flip(g, ':scope > *', move, null, true); } else { move(); }
      g.setAttribute('data-sf-built', '');
    }
    /* Shows the cards data-sf-pending held back. They were invisible while the
       grid's entrance ran, so the ones not just placed by sfApply are put back
       in the same order, which starts their entrance now instead of leaving
       them to pop in at full strength. */
    function sfRelease(g) {
      if (!g || !g.hasAttribute('data-sf-pending')) { return; }
      var kids = Array.prototype.slice.call(g.children);
      var from = -1;
      if (g.isConnected) {
        for (var i = 0; i < kids.length; i++) { if (!sfShown(kids[i])) { from = i; break; } }
      }
      g.removeAttribute('data-sf-pending');
      if (from > -1) {
        for (var j = from; j < kids.length; j++) { g.appendChild(kids[j]); }
      }
    }
    /* The pass never holds the grid for long: after SF_WAIT the server's own
       order stands and a late answer is ignored rather than swapped in. */
    var SF_WAIT = 3000;
    function sfWithin(job) {
      return new Promise(function (resolve) {
        var t = window.setTimeout(function () { resolve(null); }, SF_WAIT);
        job.then(function (v) { window.clearTimeout(t); resolve(v); }, function () { window.clearTimeout(t); resolve(null); });
      });
    }
    function announceSwap(root) {
      var ev;
      try { ev = new CustomEvent('tdhq:collection:updated', { detail: { root: root } }); }
      catch (err) { ev = document.createEvent('CustomEvent'); ev.initCustomEvent('tdhq:collection:updated', false, false, { root: root }); }
      document.dispatchEvent(ev);
    }

    /* ---- announcing the new result count -------------------------------
       The count node inside the section carries aria-live, but the whole
       section is replaced via outerHTML on every filter, sort and page: the
       node the browser was observing is destroyed and a brand new one arrives
       already containing its text, which is not a change to anything the
       browser was watching. Nothing was ever announced. This region lives on
       <body>, outside the swap, so it survives every render. */
    function liveRegion() {
      var el = document.getElementById('tdhq-collection-live');
      if (!el) {
        el = document.createElement('p');
        el.id = 'tdhq-collection-live';
        el.className = 'tdhq-visually-hidden';
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        el.setAttribute('aria-atomic', 'true');
        document.body.appendChild(el);
      }
      return el;
    }

    function announceCount(fresh) {
      var src = fresh && fresh.querySelector('[data-tdhq-collection-count]');
      var text = src ? src.textContent.replace(/\s+/g, ' ').trim() : '';
      if (!text) { return; }
      var el = liveRegion();
      /* Blank first, so filtering from one 24-result set to another 24-result
         set still fires - assigning an identical string is not a change.

         A TIMER, not requestAnimationFrame: rAF does not run while the tab is
         in the background, and an announcement that never arrives is worse than
         one that arrives late. 30ms is long enough for the blank to be observed
         and short enough to feel immediate. */
      el.textContent = '';
      window.setTimeout(function () { el.textContent = text; }, 30);
    }

    /* ---- putting focus back where the shopper was ------------------------
       Focus used to go to the <h1> after every swap, which is correct for a
       page navigation and wrong for a filter: the shopper is working in the
       facet panel, and being thrown to the top of the page means tabbing all
       the way back down for the next filter. Remember WHICH control was used
       and re-find its equivalent in the fresh markup. */
    function describeFocus() {
      var a = document.activeElement;
      if (!a || a === document.body) { return null; }
      if (a.matches('[data-tdhq-sort]')) { return { sel: '[data-tdhq-sort]' }; }
      if (a.matches('[data-tdhq-facets-toggle]')) { return { sel: '[data-tdhq-facets-toggle]' }; }
      if (a.matches('[data-tdhq-facets-apply]')) { return { sel: '[data-tdhq-facets-apply]' }; }
      if (a.name) {
        return { sel: '[name="' + a.name.replace(/"/g, '') + '"]' +
                      (a.value ? '[value="' + String(a.value).replace(/"/g, '') + '"]' : '') };
      }
      if (a.closest('.tdhq-pager')) { return { pager: (a.textContent || '').trim() }; }
      /* A removed chip is gone from the fresh markup: focus the chip that took
         its place, or the result count when it was the last one, rather than
         throwing a keyboard user back to the heading. */
      var chip = a.closest('.tdhq-chips li');
      if (chip) { return { chip: Array.prototype.indexOf.call(chip.parentNode.children, chip) }; }
      if (a.matches('a.tdhq-collection__stockchip')) { return { sel: 'a.tdhq-collection__stockchip' }; }
      if (a.matches('a.tdhq-facets__clear')) { return { sel: '.tdhq-facets__title' }; }
      if (a.closest('.tdhq-collection__brandactions')) { return { sel: '.tdhq-collection__brandactions a.tdhq-btn--primary' }; }
      return null;
    }

    function restoreFocus(hint, fresh) {
      if (!fresh) { return; }
      var target = null;
      if (hint && hint.sel) { target = fresh.querySelector(hint.sel); }
      if (hint && typeof hint.chip === 'number') {
        var chips = fresh.querySelectorAll('.tdhq-chips a[href]');
        target = chips[Math.min(hint.chip, chips.length - 1)] || fresh.querySelector('[data-tdhq-collection-count]');
      }
      if (hint && hint.pager) {
        var links = fresh.querySelectorAll('.tdhq-pager a[href]');
        for (var i = 0; i < links.length; i++) {
          if ((links[i].textContent || '').trim() === hint.pager) { target = links[i]; break; }
        }
      }
      /* Nothing equivalent survived (the last page of a pager, a facet whose
         value is now gone): the heading is the honest fallback. */
      if (!target) { target = fresh.querySelector('h1'); }
      if (target) {
        if (!target.hasAttribute('tabindex') && !target.matches('a[href], button, input, select, textarea')) {
          target.setAttribute('tabindex', '-1');
        }
        target.focus({ preventScroll: true });
      }
    }

    function sectionWrap() {
      var root = document.querySelector('[data-tdhq-collection]');
      return root && root.closest('[id^="shopify-section-"]');
    }

    /* THE HEADER PICTURE BELONGS TO THE COLLECTION, NOT TO THE FILTER (audit
       LST-02). A collection with no image of its own shows its first product's
       photo, and the first product changes with every filter and sort: the
       header swapped from the Glatt bottle to another product on each tick and
       was blank while the new one loaded, and a filter with no results left it
       with no picture at all. The picture on show is carried into the new
       render. A reload or shared link of a filtered address still renders the
       server's own choice. */
    function keepHeaderThumb(wrap, node) {
      var oldT = wrap.querySelector('.tdhq-collection__thumb');
      var newH = node.querySelector('.tdhq-collection__header');
      if (!oldT || !newH || newH.classList.contains('tdhq-collection__header--slim')) { return; }
      var newT = newH.querySelector('.tdhq-collection__thumb');
      if (newT) { newT.parentNode.replaceChild(oldT, newT); }
      else {
        newH.insertBefore(oldT, newH.firstChild);
        newH.classList.add('tdhq-collection__header--thumb');
      }
    }

    /* The listing the grid currently shows (path + query, never the #hash). */
    var listedUrl = window.location.pathname + window.location.search;

    function load(url, push) {
      var wrap = sectionWrap();
      if (!wrap) { window.location.href = url; return; }
      try { var lu = new URL(url, window.location.origin); listedUrl = lu.pathname + lu.search; } catch (e) {}
      var sectionId = wrap.id.replace('shopify-section-', '');

      if (inflight) inflight.abort();
      var ctl = ('AbortController' in window) ? new AbortController() : null;
      inflight = ctl;

      wrap.setAttribute('aria-busy', 'true');
      var focusHint = describeFocus();
      var seq = ++loadSeq;
      /* dim only when the answer is slow: a tick answered within 120 ms does not flash grey (as the blog pager) */
      window.setTimeout(function () { if (seq === loadSeq && wrap.isConnected) { wrap.classList.add('is-updating'); } }, 120);

      var u = new URL(url, window.location.origin);
      u.searchParams.set('sections', sectionId);

      /* 12 s at most, then the page loads normally (Codex 21 Oct) */
      var timedOut = false;
      var guard = ctl ? window.setTimeout(function () { timedOut = true; ctl.abort(); }, 12000) : 0;
      fetch(u.toString(), ctl ? { signal: ctl.signal } : {})
        .then(function (r) { window.clearTimeout(guard); return r.json(); })
        .then(function (data) {
          var html = data[sectionId];
          /* a section that fails to render is null inside a 200 — fall back
             to real navigation rather than leaving a dead page */
          if (!html) { window.location.href = url; return; }
          /* Built off-screen - sold-out cards moved to the end of the whole
             listing (stockFirst above) - and swapped in once, so the grid never
             shows one order and then another. */
          var tpl = document.createElement('template');
          tpl.innerHTML = html;
          var node = tpl.content.firstElementChild;
          if (!node) { window.location.href = url; return; }
          return sfWithin(stockFirst(node, sectionId, url))
            .then(function (next) {
              if (seq !== loadSeq) { return; }
              var ng = node.querySelector('[data-tdhq-collection-grid]');
              /* the grid stays settled: a filter, sort or page change arrives as one short fade of the whole grid
                 (dtc-core.css is-arriving), not a card-by-card entrance (805 ms, 21 Oct) */
              if (ng) {
                ng.classList.add('is-arriving');
                ng.addEventListener('animationend', function arrived(ev) {
                  if (ev.target !== ng) { return; }
                  ng.classList.remove('is-arriving');
                  ng.removeEventListener('animationend', arrived);
                });
              }
              if (ng && next) { sfApply(ng, next); }
              sfRelease(ng);
              keepHeaderThumb(wrap, node);
              /* An open filter drawer stays open, where it was scrolled to,
                 instead of sliding in again after every tick. */
              var oldRoot = wrap.querySelector('[data-tdhq-collection]');
              var newRoot = node.querySelector('[data-tdhq-collection]');
              var oldPanel = wrap.querySelector('[data-tdhq-facets]');
              var panelTop = oldPanel ? oldPanel.scrollTop : 0;
              if (oldRoot && newRoot && oldRoot.classList.contains('is-facets-open')) { newRoot.classList.add('is-facets-open'); }
              /* Swapping this markup in is safe by construction: the payload is our own
                 theme's Liquid, server-rendered by Shopify on the SAME origin —
                 the fetch URL is location.pathname plus params from our own form
                 and pager links, and Liquid escapes user input (e.g. filter
                 values) server-side. This is shopify.dev's documented pattern for
                 the Section Rendering API; do not route third-party or
                 user-composed strings through this path. */
              wrap.replaceWith(node);
              var newPanel = node.querySelector('[data-tdhq-facets]');
              if (push) history.pushState({ tdhqCollection: true }, '', url);
              initCollectionUI();
              /* After initCollectionUI has re-opened the lists and groups, so the saved scroll is not clipped by a
                 still-collapsed rail (Codex filters-1021 F05). */
              if (newPanel && panelTop) { newPanel.scrollTop = panelTop; }
              var fresh = sectionWrap();
              if (fresh) {
                /* The swapped-in markup contains a brand new sort <select>, and
                   `shopify:section:load` does NOT fire for the Section Rendering
                   API on the storefront - only in the theme editor. Without this
                   the custom dropdown silently reverted to a native one after the
                   first filter. */
                if (window.dtcSelectRefresh) { window.dtcSelectRefresh(fresh); }
                /* Back to the top of the results only when the shopper has
                   scrolled past it (a page link at the foot of the grid), and
                   smoothly. Filtering near the top no longer jolts the page. */
                if (fresh.getBoundingClientRect().top < 0) {
                  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                  fresh.scrollIntoView({ block: 'start', behavior: calm ? 'auto' : 'smooth' });
                }
                announceCount(fresh);
                restoreFocus(focusHint, fresh);
                announceSwap(fresh);
              }
            });
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError' && !timedOut) return;   /* replaced by a newer listing */
          window.location.href = url; /* network trouble or no answer in 12 s: degrade to normal nav */
        });
    }

    /* EVERY LINK THAT ONLY CHANGES THE LISTING RENDERS IN PLACE (audit LST-09).
       Ticking a filter was a no-reload swap, but removing the same filter with
       its chip, "Clear all", the in-stock chip, the brand band's "Shop N in
       stock" and the empty state's page and filter links were plain links: a
       white full reload and a jump to the top of the page. All of them are
       Shopify's own url_to_add / url_to_remove (or the listing's own address
       with a page or sort), so the section renders the same result without
       leaving the page. */
    var LISTING_LINKS = '.tdhq-pager a[href], .tdhq-chips a[href], a.tdhq-facets__clear, a.tdhq-collection__stockchip, ' +
      '.tdhq-collection__brandactions a.tdhq-btn--primary, .tdhq-empty a[href*="sort_by="], ' +
      /* the search results page, which uses the same rail (audit LST-13) */
      '.dtc-collection__pager a[href], a[data-tdhq-listing-link]';
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest(LISTING_LINKS);
      if (!a || !a.closest('[data-tdhq-collection]')) return;
      e.preventDefault();
      load(a.href, true);
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-tdhq-facets-form]');
      if (!form) return;
      e.preventDefault();
      /* Empty fields stay out of the URL: an untouched price range was
         writing `filter.v.price.gte=&filter.v.price.lte=` into every sorted
         or filtered address. */
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) {
        if (typeof value === 'string' && value.trim() === '') { return; }
        params.append(key, value);
      });
      var qs = params.toString();
      var target = window.location.pathname + (qs ? '?' + qs : '');
      /* The results button in the phone drawer submits the form the ticks have
         already applied: the grid on show is that result, so it is not fetched
         and faded in a second time. */
      if (target === listedUrl) { return; }
      load(target, true);
    });

    window.addEventListener('popstate', function () {
      /* back/forward re-renders the state the URL describes - but an in-page
         link ("About the brand" -> #about-brand) fires popstate too. Reloading
         the grid for it scrolled the page back up to the results as soon as
         it had reached the anchor (1,817px down, then back to 202px on
         Bio Bombs; client report 2026-09-22). Only a change of path or query
         is a new listing; a #fragment on the same listing is left alone. */
      var now = window.location.pathname + window.location.search;
      if (now === listedUrl) { return; }
      if (sectionWrap()) load(window.location.href, false);
    });

    /* A grid rendered into the page (the page as first served, or the theme
       editor re-rendering the section after a settings change): fill it
       stock-first when the section says the order may still change
       (data-sf-pending). The grid is claimed at once (data-sf-claimed), so the
       section's own safety net, which shows the held cards if this script
       never runs, stands down for THAT grid only. The claim used to be one
       page-wide flag and only the first page load ran the pass, so after an
       editor re-render the new grid's held cards were never shown: 21 of 24
       GYEON cards stayed invisible (skeptic, editor re-render at 1440). The
       held cards are always shown in the end, whatever the pass does. A grid
       that is no longer pending (the net already fired) is left exactly as
       the shopper sees it. */
    function stockFirstInPlace(wrap) {
      if (!wrap) { return; }
      var g = wrap.querySelector('[data-tdhq-collection-grid][data-sf-pending]');
      if (!g || g.hasAttribute('data-sf-claimed')) { return; }
      g.setAttribute('data-sf-claimed', '');
      var sectionId = wrap.id.replace('shopify-section-', '');
      var job;
      try { job = stockFirst(wrap, sectionId, window.location.href); }
      catch (err) { job = Promise.resolve(null); }
      sfWithin(job).then(function (next) {
        if (!g.isConnected || !g.hasAttribute('data-sf-pending')) { return; }
        try { if (next) { sfApply(g, next); } }
        catch (err) { next = null; }
        sfRelease(g);
        if (next) { announceSwap(wrap); }
      });
    }
    stockFirstInPlace(sectionWrap());

    /* THE THEME EDITOR re-renders this section in place after every change
       and fires shopify:section:load on the new markup (the Section Rendering
       swaps above never fire it). The new grid gets the same pass, its filter
       UI is wired (dtc-select.js rebuilds the sort on the same event), and the
       lists fetched for the old settings are dropped (a new page size changes
       every page). */
    document.addEventListener('shopify:section:load', function (event) {
      var sec = event.target;
      if (!sec || !sec.querySelector || !sec.querySelector('[data-tdhq-collection]')) { return; }
      sfCache = {};
      listedUrl = window.location.pathname + window.location.search;
      initCollectionUI();
      stockFirstInPlace(sec.matches('[id^="shopify-section-"]') ? sec : sec.closest('[id^="shopify-section-"]'));
    });
  })();

  /* ---------------------------------------------------------
     CUSTOMERS ALSO BROWSE: ONE TREATMENT FOR EVERY TILE PICTURE

     A tile shows a collection image or a product photo, and the rail fitted
     every one inside a 16px inset on its grey square. Right for a packshot or
     a logo on white, which melts into the grey; wrong for a photograph: Car
     Care & Detailing's 3:2 shop photo sat as a 208px picture inside its 241px
     tile beside four cut-outs that read edge to edge (audit shop-19). Liquid
     knows an image's shape, not its colours, so once it loads this reads its
     edges, the same test tdhq-quickadd.js makes for product cards:
       - two opposite light edges: a packshot or logo. Fitted, as before.
       - otherwise a photo no longer than 3:2 either way fills the tile;
       - a longer photo stays whole with its edge colours as the bars.
     If the canvas cannot be read the tile keeps the fitted default.
     --------------------------------------------------------- */
  /* Related-collection tile pictures are framed by the site-wide script
     (snippets/tdhq-fit-script.liquid); the markup marks them. */

  /* ---------------------------------------------------------
     THE VARIANT A FILTER MATCHED
     A product card links the product's one plain address (no listing tags
     for a crawler to collect). When a size or colour filter matched one
     variant the card carries its id in data-tdhq-v, and the click opens the
     product on that variant. Capture phase, so it runs before any other
     handler reads the link; a card without the attribute is untouched.
     --------------------------------------------------------- */
  function variantLink(e) {
    var a = e.target.closest && e.target.closest('a[data-tdhq-v]');
    if (!a || a.href.indexOf('variant=') > -1) return;
    a.href = a.href.split('#')[0].split('?')[0] + '?variant=' + encodeURIComponent(a.getAttribute('data-tdhq-v'));
  }
  document.addEventListener('click', variantLink, true);
  document.addEventListener('auxclick', variantLink, true);

  /* ---------------------------------------------------------
     PAGER: the current page number in view
     A list of up to 15 pages prints every page number on one line that
     scrolls sideways when it does not fit. Bring the current number to the
     middle of that line (the line only: the page itself does not move).
     --------------------------------------------------------- */
  (function () {
    var rail = document.querySelector('[data-tdhq-pager-nums]');
    var cur = rail && rail.querySelector('.is-current');
    if (!cur || rail.scrollWidth <= rail.clientWidth) return;
    var r = rail.getBoundingClientRect();
    var c = cur.getBoundingClientRect();
    rail.scrollLeft += (c.left + c.width / 2) - (r.left + r.width / 2);
  })();

  /* ---------------------------------------------------------
     COLLECTION DESCRIPTION: Read more
     Delegated on document because the collection section is replaced with
     outerHTML on every filter, sort and page, which would drop a listener
     bound to the button. The button only shows on phones (tdhq-page.css).
     --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tdhq-desc-toggle]');
    if (!btn) return;
    var desc = document.getElementById(btn.getAttribute('aria-controls'));
    if (!desc) return;
    var open = !desc.classList.contains('is-open');
    var set = function (o) {
      desc.classList.toggle('is-open', o);
      btn.setAttribute('aria-expanded', o ? 'true' : 'false');
      btn.textContent = o ? 'Read less' : 'Read more';
    };
    /* the FAQ answers' glide (TdhqMotion.resize); the fade stays on the moving edge while it closes */
    if (window.TdhqMotion && window.TdhqMotion.resize) { window.TdhqMotion.resize(desc, set, open, false); } else { set(open); }
  });

  initForms(document);

  // Editing a form section in the theme editor re-renders it, which discards
  // the listeners bound above.
  document.addEventListener('shopify:section:load', function (event) {
    initForms(event.target);
  });

  /* ---------------------------------------------------------
     POST-SUBMIT FOCUS
     Shopify reloads the page after a contact-form post, so without this
     the outcome is announced nowhere and the visitor is left at the top
     of the page unsure whether anything happened.
     --------------------------------------------------------- */
  (function formOutcome() {
    var target = document.querySelector('[data-tdhq-form-err]') ||
                 document.querySelector('[data-tdhq-form-ok]');
    if (!target) return;

    target.focus({ preventScroll: true });
    target.scrollIntoView({ block: 'center', behavior: 'auto' });
  })();
})();

/* ============================================================
   BLOG PAGES CHANGE IN PLACE (owner 21 Oct: "when you change pages in blogs its super bad now and not smooth at
   all"). The pager's links were full page loads that landed on the big banner again. A pager link now swaps only
   the results region (sections/dtc-blog.liquid #blog-results) through the Section Rendering API, the documented
   pattern also used for the collection grid: the banner and the filters stay, the next page is warmed on hover or
   touch, the old results dim only if the answer takes over 120ms, the new page fades in, the view moves to the
   results when they are off screen, and focus goes to the article count. The address changes with pushState and
   Back/Forward restore both the page and where the reader was. The links stay real ?page=N addresses: a modified
   click, no script, an error or an unexpected answer is an ordinary page load.
   ============================================================ */
(function () {
  'use strict';
  if (!('fetch' in window) || !window.history || !history.pushState || !('content' in document.createElement('template'))) { return; }
  var SEL = '[data-tdhq-blog-results]';
  function region() { return document.querySelector(SEL); }
  if (!region()) { return; }
  var warm = {};
  var ctl = null;
  var seq = 0;
  var listed = location.pathname + location.search;

  function state(extra) {
    var s = {};
    var cur = history.state;
    if (cur && typeof cur === 'object') { for (var k in cur) { if (Object.prototype.hasOwnProperty.call(cur, k)) { s[k] = cur[k]; } } }
    for (var j in extra) { if (Object.prototype.hasOwnProperty.call(extra, j)) { s[j] = extra[j]; } }
    return s;
  }
  try { history.replaceState(state({ tdhqBlog: 1, y: window.scrollY }), ''); } catch (e) {}
  /* the entry keeps where the reader scrolled to, so Forward comes back there, not to the top (Codex 21 Oct) */
  var yTimer = 0;
  window.addEventListener('scroll', function () {
    window.clearTimeout(yTimer);
    yTimer = window.setTimeout(function () {
      if (!region()) { return; }
      try { history.replaceState(state({ tdhqBlog: 1, y: window.scrollY }), ''); } catch (e) {}
    }, 300);
  }, { passive: true });

  function sectionUrl(url) {
    var r = region();
    var wrap = r && r.closest('[id^="shopify-section-"]');
    if (!wrap) { return null; }
    var u = new URL(url, location.origin);
    u.searchParams.set('section_id', wrap.id.replace('shopify-section-', ''));
    return u.toString();
  }
  function get(url) {
    var su = sectionUrl(url);
    if (!su) { return Promise.reject(new Error('no section')); }
    if (!warm[su]) {
      /* 12 s at most, then the page loads normally (Codex 21 Oct: a stalled request left the list dimmed) */
      var ctl = ('AbortController' in window) ? new AbortController() : null;
      var guard = ctl ? window.setTimeout(function () { ctl.abort(); }, 12000) : 0;
      warm[su] = fetch(su, ctl ? { credentials: 'same-origin', signal: ctl.signal } : { credentials: 'same-origin' }).then(function (res) {
        window.clearTimeout(guard);
        if (!res.ok) { throw new Error('HTTP ' + res.status); }
        return res.text();
      });
      warm[su].catch(function () { delete warm[su]; });
    }
    return warm[su];
  }

  function load(url, push, restoreY) {
    var r = region();
    if (!r) { location.href = url; return; }
    var my = ++seq;
    /* the page being loaded is the page listed from now on (as the collection pager): Back then Forward before
       the first answer came used to show page 1 under a page 2 address (Codex 21 Oct) */
    try { var lu = new URL(url, location.origin); listed = lu.pathname + lu.search; } catch (e) {}
    var busy = window.setTimeout(function () { if (my === seq) { r.classList.add('is-updating'); r.setAttribute('aria-busy', 'true'); } }, 120);
    get(url).then(function (html) {
      if (my !== seq) { return; }
      window.clearTimeout(busy);
      var tpl = document.createElement('template');
      tpl.innerHTML = html;
      var fresh = tpl.content.querySelector(SEL);
      if (!fresh) { location.href = url; return; }
      var cur = region();
      if (!cur) { location.href = url; return; }
      fresh.classList.add('is-arriving');
      cur.replaceWith(fresh);
      fresh.addEventListener('animationend', function arrived(ev) {
        if (ev.target !== fresh) { return; }   /* a card picture's own fade-in bubbles up first */
        fresh.classList.remove('is-arriving');
        fresh.removeEventListener('animationend', arrived);
      });
      listed = new URL(url, location.origin).pathname + new URL(url, location.origin).search;
      if (push) { history.pushState({ tdhqBlog: 1, y: 0 }, '', url); }
      /* the title follows the page, in the server's own "| Page N |" form */
      var pg = Number(new URL(url, location.origin).searchParams.get('page')) || 1;
      var tt = document.title.replace(/ \| Page \d+(?= \|)/, '');
      if (pg > 1) { tt = tt.indexOf(' | ') > -1 ? tt.replace(/ \| (?!.* \| )/, ' | Page ' + pg + ' | ') : tt + ' | Page ' + pg; }
      document.title = tt;
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (typeof restoreY === 'number') {
        window.scrollTo(0, restoreY);
      } else {
        var top = fresh.getBoundingClientRect().top;
        if (top < 0 || top > window.innerHeight * 0.6) { fresh.scrollIntoView({ block: 'start', behavior: calm ? 'auto' : 'smooth' }); }
      }
      var count = fresh.querySelector('.dtc-blog__count');
      if (count && typeof restoreY !== 'number') {
        count.setAttribute('tabindex', '-1');
        count.focus({ preventScroll: true });
      }
    }).catch(function () {
      window.clearTimeout(busy);
      if (my === seq) { location.href = url; }
    });
  }

  function pagerLink(e) {
    var a = e.target && e.target.closest ? e.target.closest(SEL + ' .dtc-blog__pager a[href]') : null;
    if (!a || a.origin !== location.origin) { return null; }
    return a;
  }
  ['pointerenter', 'focusin', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function (e) { var a = pagerLink(e); if (a) { get(a.href).catch(function () {}); } }, { capture: true, passive: true });
  });
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
    var a = pagerLink(e);
    if (!a) { return; }
    e.preventDefault();
    try { history.replaceState(state({ tdhqBlog: 1, y: window.scrollY }), ''); } catch (err) {}
    load(a.href, true);
  });
  window.addEventListener('popstate', function (e) {
    if (!region()) { return; }
    var now = location.pathname + location.search;
    if (now === listed) { return; }
    var st = e.state;
    load(location.href, false, st && typeof st.y === 'number' ? st.y : undefined);
  });
})();
